/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Attachment {
    getFixupPrototypeFunction() { return Attachment.fixupPrototype; }

    static newInstance(model: Partial<Attachment>): Attachment {
        let obj = Object.assign(new Attachment(), model);
        Attachment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Attachment>): Attachment {
        if (!model) return null;
        return Attachment.newInstance(<Attachment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Attachment) {
        if (!obj) return;

        models.Attachment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Attachment): boolean {
        Object.setPrototypeOf(obj, Attachment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    id: string;

    /**
     * Date and Time of the attachment
     */
    created_at: Date;

    /**
     * Creator of the attachment
     */
    created_by: string;

    /**
     * Last update of the attachment
     */
    updated_at: Date;

    /**
     * Updated By
     */
    updated_by: string;

    /**
     * Name of the attachment
     */
    name: string;

    /**
     * Description of the attachment
     */
    description: string;

    /**
     * Original file name of the attachment
     */
    file_name: string;

}
